import Vue from 'vue'
import VueRouter from 'vue-router'
// import contribution from '../views/contribution.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/contribution',
    name: 'contribution',
    component: () => import(/* webpackChunkName: "contribution" */ '../views/contribution.vue'),
    meta: {
      options: [
        {
          name: '中国室内设计年鉴',
          path: '/'
        },
        {
          name: '立即投稿',
          path: '/contribution'
        }
      ]
    }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "user" */ '../views/user/index.vue'),
    meta: {
      options: [
        {
          name: '个人中心',
          path: '/userCenter'
        }
      ]
    },
    children: [
      {
        path: '/userCenter',
        name: 'userCenter',
        component: () => import(/* webpackChunkName: "userCenter" */ '../views/user/userCenter.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
          ]
        }
      },
      {
        path: '/userInfo',
        name: 'userInfo',
        component: () => import(/* webpackChunkName: "userInfo" */ '../views/user/userInfo.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '会员信息',
              path: '/userInfo'
            },
          ]
        }
      },
      {
        path: '/designerRegister',
        name: 'designerRegister',
        component: () => import(/* webpackChunkName: "designerRegister" */ '../views/user/designerRegister.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '设计师入驻',
              path: '/designerRegister'
            },
          ]
        }
      },
      {
        path: '/changePassword',
        name: 'changePassword',
        component: () => import(/* webpackChunkName: "changePassword" */ '../views/user/changePassword.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '修改密码',
              path: '/changePassword'
            },
          ]
        }
      },
      {
        path: '/uploadWork',
        name: 'uploadWork',
        component: () => import(/* webpackChunkName: "uploadWork" */ '../views/user/uploadWork.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '发布作品',
              path: '/uploadWork'
            },
          ]
        }
      },
      {
        path: '/myWork',
        name: 'myWork',
        component: () => import(/* webpackChunkName: "myWork" */ '../views/user/myWork.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '作品管理',
              path: '/myWork'
            },
          ]
        }
      },
      {
        path: '/workDetails/',
        name: 'workDetails',
        component: () => import(/* webpackChunkName: "workDetails" */ '../views/user/workDetails.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '作品详情',
              path: '/workDetails/'
            },
          ]
        }
      },
      {
        path: '/myDraft',
        name: 'myDraft',
        component: () => import(/* webpackChunkName: "myDraft" */ '../views/user/myDraft.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '我的投稿',
              path: '/myDraft'
            },
          ]
        }
      },
      {
        path: '/draftDetails',
        name: 'draftDetails',
        component: () => import(/* webpackChunkName: "draftDetails" */ '../views/user/draftDetails.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '投稿详情',
              path: '/draftDetails'
            },
          ]
        }
      },
      {
        path: '/myOrder',
        name: 'myOrder',
        component: () => import(/* webpackChunkName: "myOrder" */ '../views/user/myOrder.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '投稿订单',
              path: '/myOrder'
            },
          ]
        }
      },
      {
        path: '/orderDetails',
        name: 'orderDetails',
        component: () => import(/* webpackChunkName: "orderDetails" */ '../views/user/orderDetails.vue'),
        meta: {
          options: [
            {
              name: '个人中心',
              path: '/userCenter'
            },
            {
              name: '订单详情',
              path: '/orderDetails'
            },
          ]
        }
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 全局前置守卫
router.beforeEach((to, from, next) => {
  // 获取 token
  const token = localStorage.getItem('token')

  // 需要登录的页面
  const requireAuth = ['/contribution', '/userCenter', '/userInfo', '/designerRegister', '/changePassword',
    '/uploadWork', '/myWork', '/workDetails/', '/myDraft', '/draftDetails',
    '/myOrder', '/orderDetails']

  if (requireAuth.includes(to.path) || to.path.startsWith('/user')) {
    if (token) {
      // 已登录，继续访问
      next()
    } else {
      // 未登录，重定向到首页或登录页
      // console.warn('请先登录')
      // next('/')
      localStorage.setItem('loginAlert', 'true')
      window.location.href = window.location.origin
      next(false)
    }
  } else {
    // 不需要登录的页面，直接访问
    next()
  }
})

// 路由守卫 - 全局后置钩子
router.afterEach((to, from) => {
  // 可以在这里添加页面访问日志等功能
  // console.log(`路由从 ${from.path} 跳转到 ${to.path}`)
})

export default router
